/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enter_A_TeamInputs */

const th_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งทีมเข้าแข่งขัน`)
};

const en_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a team`)
};

const ja_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームを参加させる`)
};

const zh_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报名参赛`)
};

const es_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscribir un equipo`)
};

const pt_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrever um time`)
};

const id_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftarkan tim`)
};

const fr_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrire une équipe`)
};

const tl_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magpasok ng team`)
};

const vi_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký một đội`)
};

const ko_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀 등록`)
};

const de_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team melden`)
};

const ru_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявить команду`)
};

const tr_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takım kaydet`)
};

const it_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscrivi una squadra`)
};

const pl_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgłoś drużynę`)
};

const uk_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявити команду`)
};

const hi_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम दर्ज करें`)
};

const ar_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل فريق`)
};

const ms_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftarkan pasukan`)
};

const bn_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল নিবন্ধন করুন`)
};

const zh_tw2_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報名球隊`)
};

const zh_hk2_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報名球隊`)
};

const ur_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیم درج کریں`)
};

const fa_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ثبت تیم`)
};

const sw_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sajili timu`)
};

const nl_enter_a_team = /** @type {(inputs: Enter_A_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team inschrijven`)
};

/**
* | output |
* | --- |
* | "Enter a team" |
*
* @param {Enter_A_TeamInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const enter_a_team = /** @type {((inputs?: Enter_A_TeamInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enter_A_TeamInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_enter_a_team(inputs)
	if (locale === "ja") return ja_enter_a_team(inputs)
	if (locale === "zh") return zh_enter_a_team(inputs)
	if (locale === "es") return es_enter_a_team(inputs)
	if (locale === "pt") return pt_enter_a_team(inputs)
	if (locale === "id") return id_enter_a_team(inputs)
	if (locale === "fr") return fr_enter_a_team(inputs)
	if (locale === "tl") return tl_enter_a_team(inputs)
	if (locale === "vi") return vi_enter_a_team(inputs)
	if (locale === "ko") return ko_enter_a_team(inputs)
	if (locale === "de") return de_enter_a_team(inputs)
	if (locale === "ru") return ru_enter_a_team(inputs)
	if (locale === "tr") return tr_enter_a_team(inputs)
	if (locale === "it") return it_enter_a_team(inputs)
	if (locale === "pl") return pl_enter_a_team(inputs)
	if (locale === "uk") return uk_enter_a_team(inputs)
	if (locale === "hi") return hi_enter_a_team(inputs)
	if (locale === "ar") return ar_enter_a_team(inputs)
	if (locale === "ms") return ms_enter_a_team(inputs)
	if (locale === "bn") return bn_enter_a_team(inputs)
	if (locale === "zh-TW") return zh_tw2_enter_a_team(inputs)
	if (locale === "zh-HK") return zh_hk2_enter_a_team(inputs)
	if (locale === "ur") return ur_enter_a_team(inputs)
	if (locale === "fa") return fa_enter_a_team(inputs)
	if (locale === "sw") return sw_enter_a_team(inputs)
	if (locale === "nl") return nl_enter_a_team(inputs)
	return en_enter_a_team(inputs)
});